import { render, staticRenderFns } from "./disablesale.vue?vue&type=template&id=3f38153d&scoped=true"
import script from "./disablesale.vue?vue&type=script&lang=js"
export * from "./disablesale.vue?vue&type=script&lang=js"
import style0 from "./disablesale.vue?vue&type=style&index=0&id=3f38153d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38153d",
  null
  
)

export default component.exports